import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  activateUserByUsername,
  fetchUsers,
  updateProfileAction,
} from './usersAction'
import { UpdateProfileResponse, UsersState } from '../../types/userTypes'
const defaultCurrency = localStorage.getItem('currency') || 'TND'
localStorage.setItem('currency', defaultCurrency)
const initialState: UsersState = {
  users: [],
  loading: false,
  error: null,
  activateMessage: null,
  currency: defaultCurrency,
  updateProfileMessage: null,
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setCurrencyClient: (state, action: PayloadAction<string>) => {
      state.currency = action.payload
      localStorage.setItem('currency', action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false
        state.users = action.payload
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
      .addCase(activateUserByUsername.fulfilled, (state, action) => {
        state.activateMessage = action.payload
        const user = state.users.find((u) => u.username === action.meta.arg)
        if (user) user.enabled = true
      })
      .addCase(activateUserByUsername.rejected, (state, action) => {
        state.error = action.payload || 'Failed to activate user.'
      })
      .addCase(updateProfileAction.pending, (state) => {
        state.loading = true
        state.error = null
        state.updateProfileMessage = null
      })
      .addCase(
        updateProfileAction.fulfilled,
        (state, action: PayloadAction<UpdateProfileResponse>) => {
          state.loading = false
          state.updateProfileMessage = action.payload.message
        }
      )
      .addCase(updateProfileAction.rejected, (state, action) => {
        state.loading = false
        state.error =
          action.payload ?? 'An error occurred while updating profile'
        state.updateProfileMessage = null
      })
  },
})
export const { setCurrencyClient } = usersSlice.actions
export default usersSlice.reducer
